<template>
  <internal-process
    class="manage-series-container"
    @go-back="backHandler"
    :process-name="processTitle"
    :with-main-background="withMainBackground"
    :with-footer-background="withFooterBackground"
  >
    <template v-if="isLoading">
      <div class="loading-spinner">
        <mds-loader></mds-loader>
      </div>
    </template>
    <template v-else>
      <component
        v-bind:is="currentComponent"
        :class="classContainer"
        :componentData="componentData"
        @component-action="componentActionHandler"
        @continue="continueHandler"
      ></component>
    </template>
    <modal />
  </internal-process>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { config } from '@/config/manage-series-steps.json';
import { concat, find, get } from 'lodash';
import SeriesStepperMixin from '@/mixins/SeriesStepperMixin';
import Modal from '@/components/atoms/Modal';
import CreateNewSeries from '@/components/organisms/CreateNewSeries';
import SeriesFundsFinalSelection from '@/components/organisms/SeriesFundsFinalSelection';
import EditSeriesName from '@/components/organisms/EditSeriesName';
import * as TargetSeries from '@/services/TargetSeries';

export default {
  name: 'manage-series',
  components: {
    'create-new-series': CreateNewSeries,
    'series-funds-final-selection': SeriesFundsFinalSelection,
    'edit-series-name': EditSeriesName,
    Modal,
  },
  mixins: [
    SeriesStepperMixin(config),
  ],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    seriesId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      filteredList: [],
      selectedSeries: {},
      componentData: {},
    };
  },
  async created() {
    this.setIsLoading(true);
    if (!(this.seriesId && this.clientId)) {
      await this.$router.push({
        name: 'notFound',
      });
      return false;
    }
    this.updateComponentData();
    TargetSeries.getSeriesListByFiduciaryId(this.fiduciary.id)
      .then((response) => {
        this.listData = this.formatData(response.data);
        this.filteredList = this.listData;
        this.seriesCheckedHandler(this.seriesId);
        this.updateComponentData();
        this.setIsLoading(false);
      })
      .catch(() => {
        this.setIsLoading(false);
      });
    return this.componentData;
  },
  methods: {
    ...mapActions([
      'logError',
      'setIsLoading',
      'setSelectedFundToBeAdded',
      'openNotification',
      'cleanSelectedFundsList',
    ]),
    updateComponentData() {
      try {
        const clientSelected = this.clientList.filter((item) => +item.id === +this.clientId)[0];
        const selectedClient = {
          id: clientSelected?.id,
          name: clientSelected?.client?.clientName,
        };
        this.componentData = {
          ...this.componentData,
          selectedSeries: this.selectedSeries,
          selectedClient,
        };
      } catch (err) {
        // handle gracefully
      }
    },
    formatData(listData) {
      const formatedListData = listData.map((series) => {
        return {
          ...series,
          manageSeries: true,
          belongsToSelectedClient: get(series, 'fiduciaryClientId') === get(this.clientId, 'id'),
        };
      });
      if (!this.newSeries) {
        return formatedListData;
      }
      return concat(this.newSeries, formatedListData);
    },
    setIsLoading(isLoading) {
      this.isLoading = isLoading;
    },
    seriesCheckedHandler(seriesId) {
      if (seriesId) {
        this.selectedSeries = find(this.filteredList, (item) => +item.id === +seriesId);
      }
    },
    componentActionHandler(event) {
      switch (event.name) {
        case 'go-to-create-new-series':
          this.currentStep = this.getStepById('create-series');
          break;
        case 'go-to-edit-series-name':
          this.currentStep = this.getStepById('edit-series-name');
          break;
        case 'selected-series-and-continue':
          this.selectedSeries = event.selectedSeries;
          this.setSelectedSeries(event.name);
          break;
        case 'selected-new-series-pending':
          this.selectedSeries = event.newSeries;
          this.setSelectedSeries(event.name);
          this.continueHandler();
          break;
        case 'edited-series-name-pending':
          this.selectedSeries = event.editedSeries;
          this.setSelectedSeries(event.name);
          this.continueHandler();
          break;
        default:
          this.currentStep = this.getStepById('funds-final-selection');
          break;
      }
      return event.name;
    },
    setSelectedSeries(eventName) {
      this.componentData = {
        ...this.componentData,
        selectedSeries: this.selectedSeries,
      };

      if (eventName !== 'selected-series-and-continue') {
        this.openNotification({
          title: 'The changes has been saved',
          tinted: true,
        });
      }
    },
    hasSelectedFund() {
      return this.selectedFund && this.selectedFund.slug === this.fundSlug;
    },
  },
  computed: {
    ...mapState({
      selectedClient: (state) => state.grid.client.selected,
      selectedClientName: (state) => state.grid.client.name,
      fiduciary: (state) => state.user.fiduciary,
      clientList: (state) => state.grid.clientList,
    }),
    newSeries() {
      return (get(this.componentData.selectedSeries, 'isNew')) ? this.componentData.selectedSeries : null;
    },
  },
  beforeDestroy() {
    this.setSelectedFundToBeAdded(null);
    this.cleanSelectedFundsList();
  },
};
</script>

<style lang="scss">
.whiteLayout {
  background-color: $mds-background-color-white !important;
}
</style>>
